import { render, staticRenderFns } from "./introCard.vue?vue&type=template&id=e40e06fa&scoped=true"
import script from "./introCard.vue?vue&type=script&lang=js"
export * from "./introCard.vue?vue&type=script&lang=js"
import style0 from "./introCard.vue?vue&type=style&index=0&id=e40e06fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e40e06fa",
  null
  
)

export default component.exports